(function () {
  'use strict';

  function initScrollReveal() {
    var cards = document.querySelectorAll('[data-animate-card]');
    if (!cards.length) return;

    // 浏览器不支持 IntersectionObserver 时直接显示
    if (!('IntersectionObserver' in window)) {
      cards.forEach(function (card) {
        card.classList.add('scroll-reveal', 'is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          var card = entry.target;
          var index = parseInt(card.getAttribute('data-animate-index'), 10);

          // 偶数从左，奇数从右
          var direction =
            index % 2 === 0 ? 'scroll-reveal--left' : 'scroll-reveal--right';

          card.classList.add('scroll-reveal', direction);

          // 双重 requestAnimationFrame，确保初始状态先被浏览器应用
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              card.classList.add('is-visible');
            });
          });

          observer.unobserve(card);
        });
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -50px 0px',
      },
    );

    cards.forEach(function (card) {
      observer.observe(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollReveal);
  } else {
    initScrollReveal();
  }
})();
